import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { message } from 'antd'
import Select from 'react-select'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import _ from 'lodash'
import { handleFileUpload } from '../../setup/Upload/Upload'

export function AddWebsiteAssociatedComponents() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [counter, setCounter] = useState(Array(1).fill(0))
  const [toggleCrop, setToggleCrop] = useState(false)
  const [pages, setPages] = useState([{ value: '', label: 'Select Framework' }])
  const [categories, setCategories] = useState([{ value: '', label: 'Select Framework' }])
  const [subCategories, setSubCategories] = useState([{ value: '', label: 'Select Framework' }])
  const [values, setValues] = useState([
    {
      pageURL: '',
      Category: {},
      SubCategory: {},
      AssociatedComponentMobileSS: '',
      AssociatedComponentDesktopSS: '',
      filesM: [],
      filesD: [],
    },
  ])
  const [errorArray, setErrorArray] = useState([false])
  const [loadingMob, setLoadingMob] = useState(false)
  const [loadingDesk, setLoadingDesk] = useState(false)
  const [fetchedDesk, setFetchedDesk] = useState(false)
  const [fetchedMob, setFetchedMob] = useState(false)
  const [deskfetchErr, setDeskFetchErr] = useState(false)
  const [mobfetchErr, setMobFetchErr] = useState(false)
  const [mobURL, setMobURL] = useState('')
  const [webURL, setWebURL] = useState('')
  const [desktopScreenshots, setDesktopScreenshots] = useState(null)

  const [mobileScreenshots, setMobileScreenshots] = useState(null)
  const [manualWeb, setManualWeb] = useState(false)
  const [manualMob, setManualMob] = useState(false)
  const [previous, setPrevious] = useState(0)
  const [submitError, setSubmitError] = useState(false)

  const onChange = async (event: any, i: any) => {
    const d = await handleFileUpload(event);
    const a = [...values]
    a[i].AssociatedComponentDesktopSS = d;
    setValues(a)
  }
  const onChangeMobile = async (event: any, i: any) => {
    const d = await handleFileUpload(event);
    const a = [...values]
    a[i].AssociatedComponentMobileSS = d;
    setValues(a)
  }

  useEffect(() => {
    console.log(history.location.state)
    httpService.getData(
      '/website/' + history.location.state.id,
      (res) => {
        console.log(res.data.data)
        let a = []
        res.data.data.AssociatedPages.forEach((x) => {
          a.push({ value: x.PageLink, label: x.PageLink })
        })
        setPages(a)
      },
      (err) => {
        message.error('Not able to fetch.')
        console.log(err)
      }
    )
    httpService.getData(
      '/type-master',
      (res) => {
        console.log(res.data.data.data)
        let x = []
        res.data.data.data.forEach((data) => {
          x.push({ value: data._id, label: data.Name })
        })
        setCategories(x)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )
    httpService.getData(
      '/components-master',
      (res) => {
        console.log(res.data.data.data)
        let x = []
        res.data.data.data.forEach((data) => {
          x.push({ value: data._id, label: data.Name })
        })
        setSubCategories(x)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )
  }, [])

  const skipStep = () => {

    httpService.postData(
      '/website/save/' + history.location.state.id,
      { data: {} },
      (res) => {
        message.success('Published!')
        setLoading(false)

        history.push({
          pathname: '/addWebsite/complete',
          state: {
            ...history.location.state,
          },
        })
      },
      (err) => {
        setLoading(false)
        message.error(err.message)
      }
    )

  }
  const submitForm = (e) => {
    e.preventDefault()
    console.log(values)
    let pageURL = []
    let MyCategory = []
    let SubCategory = []


    let array = []
    let EA = []

    values.forEach((v, i) => {


      if (
        _.isEqual(v, {
          pageURL: '',
          Category: {},
          SubCategory: {},
          AssociatedComponentMobileSS: '',
          AssociatedComponentDesktopSS: '',
        }) ||
        v.pageURL === '' ||
        _.isEmpty(v.Category) ||
        _.isEmpty(v.SubCategory) ||
        _.isEmpty(v.AssociatedComponentMobileSS) ||
        _.isEmpty(v.AssociatedComponentDesktopSS)
      ) {
        EA[i] = true
        setSubmitError(true)
      } else {
        EA[i] = false
      }
    })

    const fd = {
      AssociatedComponent: values,
      id: history.location.state.id,
    }

    setErrorArray(EA)

    if (_.isEqual(EA, Array(values.length).fill(false))) {
      console.log(submitError, errorArray)
      setLoading(true)
      httpService.patchData(
        '/website/update/?step=6',
        fd,
        (res) => {
          const data = res.data.data
          console.log(data)
          httpService.postData(
            '/website/save/' + history.location.state.id,
            { data },
            (res) => {
              message.success('Published!')
              setLoading(false)

              history.push({
                pathname: '/addWebsite/complete',
                state: {
                  ...history.location.state,
                },
              })
            },
            (err) => {
              setLoading(false)
              message.error(err.message)
            }
          )
        },
        (err) => {
          setLoading(false)
          console.log(err)
        }
      )
    }
  }
  useEffect(() => {
    console.log(values)
    setSubmitError(false)
    setErrorArray(Array(values.length).fill(false))
    // console.log(errorArray)
  }, [values])

  useEffect(() => {
    console.log(errorArray)
  }, [errorArray])


  // UseEffect load the values if it is editing
  useEffect(() => {
    console.log(history.location.state);

    if (history.location.state.edit) {
      setValues(history.location.state.website.AssociatedComponent.length > 0 ? history.location.state.website.AssociatedComponent : values)
    }
  }, [])

  // useEffect(() => {
  //   console.log(history)
  //   console.log(process.env.REACT_APP_API_URL.split('/api/v1')[0])

  //   let AssociatedComponents = history.location.state.website.AssociatedComponent
  //   AssociatedComponents?.forEach((component) => {
  //     component['filesM'] = []
  //     component['filesD'] = []
  //   })
  //   console.log(AssociatedComponents)
  //   setPrevious(AssociatedComponents.length)
  //   if (AssociatedComponents.length !== 0) {
  //     setValues(AssociatedComponents)
  //     setCounter(Array(AssociatedComponents.length).fill(0))
  //     setErrorArray(Array(AssociatedComponents.length).fill(false))
  //   }
  // }, [history])
  const [nameError, setNameError] = useState(false)

  return (
    <div className='CompanyDetailsOuter border '>
      <AddWebsiteLeftBreadcrum currentStep='6' />
      <form
        className='CompanyDetails'
        noValidate
        id='kt_login_signup_form'
        onSubmit={submitForm}
        style={{ marginBottom: '200px' }}
      >
        <h2 className=''>Associated Components</h2>

        {values.map((x, i) => {
          return (
            <div
              className='p-4 my-8'
              style={
                errorArray[i]
                  ? { borderRadius: '12px', border: '1px red solid' }
                  : { borderRadius: '12px', border: '1px #eff2f5 solid' }
              }
            >
              {counter.length > 1 && (
                <span
                  className='cross cursor-pointer'
                  onClick={() => {
                    if (counter.length !== 1) {
                      let x = [...counter]
                      x.pop()
                      setCounter(x)
                      let y = [...values]
                      y.splice(i, 1)
                      setValues(y)
                      if (i < previous) {
                        setPrevious((prev) => prev - 1)
                      }
                    }
                  }}
                >
                  &times;
                </span>
              )}
              <div className={counter.length > 1 ? 'row p-5 pt-0' : 'row p-5 pt-10'}>
                <div className='col '>
                  <h6 className='fw-bold required'>Select Linked page</h6>
                  <Select
                    isMulti={false}
                    name='Linked Pages'
                    options={pages}
                    value={{ value: values[i].pageURL, label: values[i].pageURL }}
                    placeholder='Select Linked pageURL'
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        height: 'auto',
                        maxHeight: '200px',
                      }),
                    }}
                    className={clsx(
                      'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                    )}
                    onChange={(e) => {
                      console.log(e)
                      let x = [...values]
                      x[i].pageURL = e.value
                      setValues(x)
                    }}
                  />
                </div>
                <div className='col '>
                  <h6 className='fw-bold required'>Page Category</h6>
                  <Select
                    isMulti={false}
                    name='Category'
                    value={values[i].Category}
                    placeholder='Select Category'
                    options={categories}
                    onChange={(e) => {
                      console.log(e)
                      let x = [...values]
                      x[i].Category = e
                      setValues(x)
                    }}
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        height: 'auto',
                        maxHeight: '200px',
                      }),
                    }}
                    className={clsx(
                      'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                    )}
                  />
                </div>
                <div className='col '>
                  <h6 className='fw-bold required'>Select Component Category</h6>
                  <Select
                    isMulti={false}
                    name='SubCategory'
                    placeholder='Select Sub-Category'
                    options={subCategories}
                    value={values[i].SubCategory}
                    onChange={(e) => {
                      console.log(e)
                      let x = [...values]
                      x[i].SubCategory = e
                      setValues(x)
                    }}
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        height: 'auto',
                        maxHeight: '200px',
                      }),
                    }}
                    className={clsx(
                      'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                    )}
                  />
                </div>
                <div className='separator my-4'></div>

                <div className='m-2'>
                  <div className='pe-5 '>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div>
                        <h6 className='required fw-normal'>DesktopSS Component View</h6>
                        <p
                          className='text-gray-500'
                          style={deskfetchErr ? { color: 'red' } : { color: 'green' }}
                        >
                          {values[i].AssociatedComponentDesktopSS && 'Upload screenshot'}
                          {!values[i].AssociatedComponentDesktopSS && 'Uplaoded Screenshot'}
                          {manualWeb && 'Manually Uploaded'}
                        </p>
                      </div>
                      <div>
                        <button
                          type='button'
                          className={
                            !values[i].AssociatedComponentDesktopSS
                              ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                              : 'screenshotComponentBtn'
                          }
                          disabled={values[i].AssociatedComponentDesktopSS ? false : true}
                          onClick={() => {
                            window.open(values[i].AssociatedComponentDesktopSS, '_blank')

                          }}
                        >
                          {values[i].AssociatedComponentDesktopSS && (
                            <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                          )}
                          &nbsp; Preview
                        </button>
                        {!loadingDesk && (
                          <button
                            type='button'
                            className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                            onClick={() => {
                              document.getElementById('desktopManual' + i).click()
                            }}
                          >
                            Click to {manualWeb ? 'Re-Uplaod' : 'Upload'}
                          </button>
                        )}
                        <input
                          type='file'
                          accept='.png, .jpg, .jpeg, .svg'
                          style={{ display: 'none' }}
                          id={'desktopManual' + i}
                          onChange={(e) => onChange(e, i)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='m-2'>
                  <div className='pe-5 '>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div>
                        <h6 className='required fw-normal'>MobileSS Component View</h6>
                        <p className='text-gray-500'>
                          {values[i].AssociatedComponentMobileSS && 'Upload screenshot'}
                          {!values[i].AssociatedComponentMobileSS && 'Uplaoded Screenshot'}
                          {manualWeb && 'Manually Uploaded'}
                        </p>
                      </div>
                      <div>
                        <button
                          type='button'
                          className={
                            !(values[i].AssociatedComponentMobileSS)
                              ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                              : 'screenshotComponentBtn'
                          }
                          onClick={() => {
                            window.open(values[i].AssociatedComponentMobileSS, '_blank')
                          }}
                          disabled={!values[i].AssociatedComponentMobileSS}
                        >
                          {values[i].AssociatedComponentMobileSS && (
                            <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                          )}
                          &nbsp; Preview
                        </button>
                        {!loadingDesk && (
                          <button
                            type='button'
                            className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                            onClick={() => {
                              document.getElementById('mobileManual' + i).click()
                            }}
                          >
                            Click to {manualMob ? 'Re-Uplaod' : 'Upload'}
                          </button>
                        )}
                        <input
                          type='file'
                          accept='.png, .jpg, .jpeg, .svg'
                          style={{ display: 'none' }}
                          id={'mobileManual' + i}
                          onChange={(e) => onChangeMobile(e, i)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {errorArray[i] && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      Fill all the fields.
                    </span>
                  </div>
                </div>
              )}
            </div>
          )
        })}

        <div className='row pe-5 pb-5 '>
          <span
            className='fw-bold addpage'
            onClick={() => {
              let x = [...counter]
              x.push(0)
              setCounter(x)
              let y = [...values]
              y.push({
                pageURL: '',
                Category: {},
                SubCategory: {},
                AssociatedComponentMobileSS: '',
                AssociatedComponentDesktopSS: '',
                filesM: [],
                filesD: [],
              })
              setValues(y)
              let z = [...errorArray]
              z.push(false)
              setErrorArray(z)
            }}
          >
            + Add Another Component
          </span>
        </div>

        <div className='d-flex pt-4 pe-5'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={() => {
              console.log('kidhar')
            }}
            disabled={loading || submitError}
          >
            {!loading && <span className='indicator-label'>Save & Submit</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <button onClick={skipStep} className='btn btn-primary ms-5 CompanyDetailButton'>
            <span className='indicator-label'>Skip</span>
          </button>
          <Link
            to={{
              pathname: '/addWebsite/associated-pages',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
              Back
            </button>
          </Link>
        </div>
      </form>
    </div>
  )
}
